import React, { forwardRef } from 'react'
import { deleteDirectory, updateAAGroup } from '../../../apiclients/streamsapi_bridge';
import { MDBBtn, MDBIcon, MDBModalFooter } from 'mdb-react-ui-kit';
import { useTranslation } from "react-i18next";

const DeleteAADirectory = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    async function removeThisDirectory(e) {
        console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        let saverep = await deleteDirectory(JSON.parse(sessionStorage.getItem("admin_session")).siteid, props.directoryid);
        console.log(saverep);
        let saverepeMsg = await saverep.json();
        if (saverepeMsg.status == "success") {
            if (props.lunaUser) {
                props.setisDirectDeleted(true);
                props.setSuccessMessage(saverepeMsg.message);
            } else {
                localStorage.setItem("s_message", saverepeMsg.message);
                window.location.href = "/dialbydirectoriesLanding";
            }
        } else {

        }
        props.onClose();
    }
    return (
        <>
            <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                <span>{t("removedailbydirectory")}</span>
            </div>

            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => { e.preventDefault(); removeThisDirectory(e); }}>
                    {t("add")}</button>
            </div>
        </>
    );
});

export default DeleteAADirectory
